module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg1.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "chtitle"
  }, [_c('b', [_vm._v("IN THE BEGINNING")])]), _vm._v(" "), _c('p', {
    staticClass: "chtitle1"
  }, [_c('i', [_c('b', [_vm._v("The Lincoln Heritage")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("With the crack of a rifle shot, eleven-year-old Josiah saw his father, mortally wounded, fall to the ground where they’d just been planting corn. Josiah took off running toward Hughes Station, the rudimentary fort his father had helped build when the family moved to Kentucky two years earlier. Just as quick to act, fourteen-year-old Mordecai ran into the family’s cabin and grabbed the gun he knew was there. Thomas, only about eight, started crying as he stood by his father’s body. Fearing Thomas would be killed and his father scalped, Mordecai acted decisively. Looking through the loose cracks of the log cabin and seeing the murderer—a Native American wearing a large silver pendant stolen from another farmer—he aimed and pulled the trigger. It was a direct hit. Mordecai had avenged the death of his father, Captain Abraham Lincoln.")])]), _c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('b', [_vm._v("LOUISVILLE, KENTUCKY")])])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Long Run Cemetery")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Tucked along a country lane near Eastwood, Kentucky, Long Run Cemetery is easy to miss at first. The only clue to this being more than an old, half-forgotten country cemetery is a sign saying that the large oak tree shading the wrought-iron gate grew out of an acorn from an oak in Albion, Illinois, under which Abraham Lincoln gave a great speech in 1844. Someone has taken care to erect markers touting the accomplishments of several people buried here. None refer to the president’s grandfather. Ringing the interior of the old burial ground are the stone foundations of the original Long Run Baptist Church, which Abraham Lincoln helped build. Near here, within a few feet of the foundations, I find the tombstone for Abraham Linkhorn (Lincoln to you and me). There are no other family members nearby. After Lincoln was shot, they all moved away, so he rests alone.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Two Hundred Years of Travelers")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Just seven miles from Long Run Cemetery, going south on the wonderfully named Old Stage Coach Road to US 60 East, is Eleanor Hamilton’s Old Stone Inn in Simpsonville, Kentucky. Built in the early 1800s, with two-foot-thick stone walls and large-planked wooden floors, each room has a fireplace, for how else would you keep warm on cold days and nights? The inn was a stagecoach stop, tavern, and hostel along the Midland Trail. President Andrew Jackson stayed here as he traveled between Tennessee and Washington, DC. Logic and oral history say that when Abraham Lincoln was a successful attorney and statesman he was a visitor there as well. “People, especially the old-timers, tell stories about him being here,” says Christopher Kayrouz, owner of the inn. It’s also possible that Lincoln might have stopped by to visit his grandfather’s grave. For those tracing Lincoln’s heritage in Kentucky, the area east of Louisville is the beginning of his family history here and thus the first stop on any trip through the Bluegrass State.")])]), _c('div', {
    staticClass: "figure"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg10_1.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "figcaption"
  }, [_vm._v("Tradition states that Captain Abraham Linkhorn (Lincoln), President Abraham Lincoln’s paternal grandfather, was buried by his cabin. A headstone memorializing the captain was placed in the Long Run Baptist Church Cemetery in 1937 and remains today near the foundation of the church. The church and cemetery were added to the National Register of Historic Places in 1975. "), _c('i', [_vm._v("Photo courtesy of Jane Simon Ammeson")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Captain Abraham Lincoln was just forty-six when he died in 1786 on the large parcel of land he’d purchased in 1780 in what would become eastern Jefferson County, about twenty miles from downtown Louisville. In 1782 he and his family had moved from Virginia and settled on “the Fork of Floyd’s Fork” (now Long Run). At that time battles between pioneers and Native Americans, who rightly considered the land their own, were fierce and bloody in this part of Kentucky. To protect themselves, pioneers erected “stations” or wooden stockades, usually located near a spring to ensure a supply of water, and typically named after the first white settler to arrive.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Abraham Lincoln had no chance to seek shelter in nearby Hughes Station when he was shot dead in his cornfield. Besides his three sons, he left a widow, Bathsheba, and two daughters, Nancy and Mary. A younger daughter, Abigail, born in 1782, appears to have died by the time of Captain Lincoln’s death. His estate included 5,544 acres of prime Kentucky land, and it would have provided all of his children a very comfortable living. But because of the law of primogeniture, Mordecai inherited the majority of his father’s estate. Bathsheba got a small share; the other children received little or nothing.")])]), _c('div', {
    staticClass: "figure"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg11_1.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "figcaption"
  }, [_vm._v("Once a stagecoach stop, the Old Stone Inn may have been a place where Lincoln visited while journeying through Kentucky. It is not far from his grandparents’ homestead and where his grandfather, Captain Abraham Lincoln, is buried. "), _c('i', [_vm._v("Photo courtesy of Jane Simon Ammeson")])]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg11_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcaption"
  }, [_vm._v("The interior of the Old Stone Inn with its solid stone walls, planked-wood floors, and fireplaces gives the feel of what it must have been like two hundred years ago.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("An English hereditary law, primogeniture was developed as a way to keep estates in the hands of one person, so they could be passed down in their entirety across the generations instead of being dissipated and spread too thin. If the oldest son died, the estate went to the next oldest male, and so on. Because a woman, even a wife, could not inherit the estate, if no sons survived, it passed to the nearest male descendent, sometimes someone unknown to the family. A widow and her children could be turned out of their home by a second nephew or some other obscure heir. For Captain Lincoln’s younger sons, Josiah and Thomas Lincoln, primogeniture meant they would have to make their own way in the world. For Bathsheba, it meant she would never seem to have a home of her own again and was left to raise five children all by herself.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indentb"
  }, [_vm._v("Bathsheba’s husband had moved her into the wilds of Kentucky and then left her on her own, but it wasn’t as if she hadn’t been warned.")]), _vm._v(" "), _c('p', {
    staticClass: "quote"
  }, [_vm._v("According to the members of the Herring family still living in the Shenandoah Valley, as reported by one of them to Mr. Lea in 1908, “Abraham Lincoln, who married Bathsheba Herring, was a poor and rather plain man. Her aristocratic father looked with scorn on the alliance and gave his daughter the choice of giving up her lover or being disinherited. The high-spirited young woman did not hesitate. She married the man she loved and went with him to the savage wilds of Kentucky in 1782. Her husband was afterwards killed by an Indian, and one of her sons, a lad of 12 years, killed the Indian, avenging his father’s death. Bathsheba Herring Lincoln was a woman of fine intelligence and strong character. She was greatly loved and respected by all who knew her.” (Ida M. Tarbell, "), _c('i', [_vm._v("In the Footsteps of the Lincolns")]), _vm._v(", 55)")])]), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('b', [_vm._v("Always Moving On")])])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Captain Lincoln’s youngest son and the future president’s father, Thomas Lincoln moved many times over the years, both as a child and as a grown man—sometimes from necessity, such as when he lost his farm because of legal issues with the title, and other times trying for a better life for his family. He wasn’t the only Lincoln who didn’t seem to think twice about packing up and hitting the road. Starting with family members who moved to America in the 1700s, the Lincolns would settle temporarily and then, despite seeming prosperity, would journey on, at times on their own but often in conjunction with the Boone family.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It would take another book just to keep track of these two families’ peregrinations. I’ll make it easy and start with chronicling Captain Abraham Lincoln’s major moves. Captain Abe (he received his title fighting in the Revolutionary War) and his family were neighbors and relatives by marriage of the Boones in Berks County, Pennsylvania. When the Boones moved from Pennsylvania to North Carolina and then on to settle in Virginia, the Lincolns left to join them.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("In May 1769, while still living in North Carolina, Daniel Boone and a small group of men began an exploration west. Years later Boone would write, with the help of a friend,")]), _vm._v(" "), _c('p', {
    staticClass: "quote"
  }, [_vm._v("We proceeded successfully; and after a long and fatiguing journey through a mountainous wilderness, in a westward direction, on the seventh day of June following we found ourselves on Red River, where John Finley had formerly gone trading with the Indians; and, from the top of an eminence, saw with pleasure the beautiful level of Kentucky….")]), _vm._v(" "), _c('p', {
    staticClass: "quoteib"
  }, [_vm._v("We found everywhere abundance of wild beasts of all sorts, through this vast forest. The buffalo were more frequent than I have seen cattle in the settlements, browsing on the leaves of the cane, or cropping the herbage on those extensive plains, fearless, because ignorant, of the violence of man. Sometimes we saw hundreds in a drove, and the numbers about the salt springs were amazing. (Gilbert Imlay, "), _c('i', [_vm._v("A Topographical Description of the Western Territory of North America")]), _vm._v(", 339)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("To Boone, Kentucky was a paradise and he resolved to move his family there. After listening to descriptions like this and hearing Boone say, “Heaven must be a Kentucky kind of place,” of course the Lincolns would follow. And so off they all eventually went.")])]), _c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('b', [_vm._v("SPRINGFIELD, KENTUCKY")])])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("As we know, settling on Floyd’s Fork would be the last earthly move for the captain, but his widow, Bathsheba, moved several more times during her long life, mostly living with relatives, as her husband’s death had left her in a precarious financial position. Her children accompanied her until they grew up and married. Moving in with relatives was the norm in early pioneer days, even when a typical home was a one-room log cabin, only sometimes with an upper loft area. There often seemed to be an overabundance of aunts, uncles, elderly parents, cousins, neighborhood orphans, nieces, and nephews living together.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bathsheba’s first move after Captain Lincoln’s death was to Springfield, Kentucky. It couldn’t have been an easy trip for Bathsheba and her brood. Though the trip from Long Run to Springfield south on KY 555 takes me a little over an hour, those fifty-four miles in Bathsheba’s time most likely took a couple of days, loaded down as she was with children and furniture.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In Springfield, I visit the Lincoln Homestead State Park, which houses re-creations of the 1782 cabin and blacksmith shop where Tom Lincoln spent his youth and learned a trade. It’s an interesting piece of history, but what is more amazing is the juxtaposition of the raw living and working conditions of Thomas with those of his oldest brother, Mordecai, who lived in comparative pioneer splendor, emphasizing again the impact Abraham Lincoln’s early death would have on the lives of his sons. Mordecai would become a landed gentleman and breed racehorses, while Tom could barely afford an old nag to carry sacks of grain to the mill.")])]), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('b', [_vm._v("Mord")])])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("After coming of age and collecting his inheritance, Mord (as Mordecai was called) married Mary Mudd. The two built a two-story cabin and had six children, including another Mordecai. Pioneer families often used the same first names in each succeeding generation, which was a good way to honor ancestors, but is really a pain for genealogists and historians.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mord and Mary’s cabin was enlarged and its facade enhanced by its second owner. Now listed on the National Register of Historic Places, the Mordecai Lincoln Homestead is located about a mile from the main visitor center at the Lincoln Homestead State Park. It is the only existing structure owned and occupied by a member of the Lincoln family in Kentucky still standing on its original site.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lincoln resembled his Uncle Mord physically, and both were known for their wit, common sense, storytelling ability, and compassion. A less favorable family trait that affected both uncle and nephew was a strong tendency toward melancholy. Lincoln often told people that his intelligent, humorous, and talented uncle influenced him greatly, adding that “Uncle Mord had run off with all the talents of the family.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a strange twist of history, Mary Mudd Lincoln was a first cousin twice removed of Dr. Samuel A. Mudd, who treated John Wilkes Booth for the wound he received during his escape after shooting President Lincoln at Ford’s Theater. Having failed to report the incident for twenty-four hours, Mudd was tried as a conspirator in the president’s murder. Luckily for the doctor, he escaped the death penalty by one vote and instead was sentenced to life in prison. President Andrew Johnson, Lincoln’s successor, pardoned the doctor in 1869, in part because he helped stem an outbreak of yellow fever while imprisoned in Florida. Before his trial and conviction, Samuel and his wife had produced four children. After his release, they added five more to their brood. Imagine how many more they might have had if he hadn’t spent those years in jail. That poor woman got a lucky break.")])]), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('b', [_vm._v("The Future Mrs. Thomas Lincoln")])])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Springfield would be the nexus for many happenings in the Lincoln family, but most important, it was where Thomas would meet his future wife Nancy Hanks—entranced, it is said, by her ability to spin thread. Nancy had come from Virginia and was living near Springfield, Kentucky, with Richard Berry Sr., who was married to Rachel Shipley Berry, the sister of Nancy’s mother, Lucy Shipley. Their home, now called the Francis Berry House, is where Tom Lincoln, then living in Elizabethtown, proposed to Nancy. It is also now on the grounds of Lincoln Homestead State Park in Springfield, having been moved in 1941 from where it originally stood about a mile away. The two-story log cabin is decidedly more upscale than the one-room cabins Nancy would live in after marrying Thomas. The exterior logs and some of the furnishings are original, and Nancy’s upstairs bedroom (yes, she had a bedroom though we’re not sure how many people she shared it with) looks cozy and comfortable.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Family Scandals")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pioneer life was in many ways just as undisciplined as our own times, as the lifestyles and rumors about the Lincoln and Hanks families show. For those who consider our era morally corrupt compared to the good old days, consider the history of the Hanks women, who it seems, might have been somewhat overexuberant when it came to premarital sex. Nancy Hanks Lincoln’s sister Sarah or Polly Hanks never married although she had six children, all of whom grew to maturity and bore their mother’s last name. One of those children was Sophie Hanks, who, after her mother died, came to live for a time with Nancy and Tom after they moved to Indiana.")])]), _c('p', {
    staticClass: "indentb"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Nancy Hanks Lincoln was an excellent seamstress and fantastic mother; of that we have no doubt. But it seems she may also have been, as they said back then, born on the wrong side of the blanket. Whatever. I don’t care. But I’m always willing to pass on gossip. Nancy’s ancestry is very complex, and DNA ")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("testing is still trying to sort it all out. It appears that her mother was probably Lucy Hanks—there’s some dispute about that, but it’s so complicated that you’ll have to trust us on that. Lucy wasn’t married when Nancy was born, and her father may have been either James Hanks or Henry Sparrow—although other names are suggested as well. Lucy eventually married Henry Sparrow, but only after she faced “fornication” charges. Sparrow was a reverend and Lucy his housekeeper, and, well, you know, people will talk. So in November 1789, a grand jury of twelve men (remember, women couldn’t vote back then, nor could they serve on juries) convened to take up charges against Lucy. Interestingly no one filed similar charges against Sparrow. Anyway, he decided to do the right thing and the couple took out a marriage license on April 26, 1790, married a week later, and on May 25, 1790, an order was entered to discontinue the case. But Lucy was never cleared of the charges in her lifetime, or indeed for over a century, until two attorneys decided to rectify that.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "h3"
  }, [_c('b', [_vm._v("Lincoln’s Grandmother Suit Filed to Clear Lucy Hanks’s Name")])]), _vm._v(" "), _c('p', {
    staticClass: "quote"
  }, [_c('i', [_vm._v("Advocate-Messenger")]), _vm._v(", Danville, KY, Thursday, September 9, 1976")]), _vm._v(" "), _c('p', {
    staticClass: "quotei"
  }, [_vm._v("An effort is being made in Mercer Circuit Court to purge the name of Abraham Lincoln’s grandmother, Lucy Hanks, who was accused of fornication in 1789.")]), _vm._v(" "), _c('p', {
    staticClass: "quotei"
  }, [_vm._v("A suit styled Commonwealth of Kentucky vs. Lucy Hanks has been filed by Attorney James A. Peterson, a historian of White Oaks Spring Farm, Yorkville, IL, and by local Attorney David Taylor, as friends of the Court and on behalf of the heirs of Lucy Hanks.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Who’s Your Daddy?")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("As for whether James Hanks or Henry Sparrow was Nancy’s father, though history knows her as Hanks, Sparrow was the last name she often used of at that time of her life. More speculatively, some historians claim that Abraham Lincoln wasn’t ")]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Tom’s son but instead was fathered by a man with the last name of Enlow or Enloe. There were Enlows who were friends of the Lincolns and who also moved to southwestern Indiana, where they owned the Enlow Mill in Jasper. Mrs. Enlow was said to have helped deliver Abraham while they still lived in Kentucky. If he truly were her husband’s child, that seems mighty nice of her.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Even Abe seemed unsure of his heritage. According to William Herndon, Lincoln’s law partner and biographer, Lincoln told him his maternal grandfather was “a well-bred Virginia farmer or planter.” I told you it was complicated.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("So much of what we know of pioneer life is from movies and TV shows, but it was really a much more nuanced time as the following article, dating back almost 150 years, shows.")]), _vm._v(" "), _c('p', {
    staticClass: "quote"
  }, [_c('i', [_vm._v("The Indiana Herald")])]), _vm._v(" "), _c('p', {
    staticClass: "quotei"
  }, [_vm._v("Huntington Indiana")]), _vm._v(" "), _c('p', {
    staticClass: "quotei"
  }, [_vm._v("Wednesday, March 18, 1874")]), _vm._v(" "), _c('p', {
    staticClass: "quotei"
  }, [_vm._v("In the year 1859, I went to Springfield, Kentucky to teach and was in that neighborhood when Abraham Lincoln received the nomination for president. On the announcement of the name of the candidate a farmer remarked that “you should not be surprised if this were a son of Thomas Lincoln and Nancy Hanks who were married at the house of Uncle Frank Berry.” (the old house is still standing)")]), _vm._v(" "), _c('p', {
    staticClass: "quotei"
  }, [_vm._v("A few days later I visited an aged lady by the name of Litsey, who interested me much by giving a description of the wedding of the father and mother of the new candidate; she having been a friend of the bride and present at the wedding. In 1866 after the liberation of 4 million slaves had made the name of Abraham Lincoln memorable, I was again in the neighborhood and visited the old home, now historic, in which were celebrated the nuptial rights referred to above.")])]), _c('p', {
    staticClass: "quotei"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Its surroundings are among the most picturesque in Kentucky. The Beech Fork, a small river of wonderful meanderings, flows near, and is lost to view in a semi-circular amphitheater of hills. As I remember the story of Nancy Hanks, it ran thus. Her father and mother were Virginians and died when she was young; her mother’s name was Shipley and she is known to have had two ")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("sisters, one of whom married a man by the name of Berry, and the other, Robert Mitchell, who came to Kentucky about the year 1789. While on the journey, this family was set upon by the Indians and Mrs. M. fatally wounded, and their only daughter, Sarah, a child of 11, was captured and carried away. Mr. Mitchell bore his dying wife to Crab Orchard and like Abraham of old, purchased that renowned spot for the burial place of his wife. After the last sad rites, he mounted his horse, accompanied by his friend, Gen. Adair and went in search of his daughter, but was drowned in Dick’s River while attempting to cross.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "quoteib"
  }, [_vm._v("C.C.H.V.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For those wondering about poor Sarah, now an orphan and captive of the Indians, shortly after “Mad Anthony” Wayne’s Treaty of the Timbers with the Indians in 1794, she was rescued and went to live in the Berry home where Nancy was residing. The two became good friends and Nancy, who was a whiz with a spinning wheel, taught Sarah what was described even then as the “lost art” of spinning.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("C.C.H.V., whose full name we don’t know, also offered a description of what convinced Thomas that Nancy would make an excellent wife.")]), _vm._v(" "), _c('p', {
    staticClass: "quote"
  }, [_vm._v("It was the custom in those days to have spinning parties, on which occasions the wheels of the ladies were carried to the house designated, to which the competitors came distaff in hand, ready for the work of the day. At a given hour, the wheels were put in motion and the filmy fiber took the form of firmly lengthened strand in their mystic hands, fence strand in their mental hand.")]), _vm._v(" "), _c('p', {
    staticClass: "quotei"
  }, [_vm._v("Tradition says Nancy bore the palm using the finest and longest threads. Mr. Lincoln was not an exception to the rule for great men which requires that their mother shall be talented. Thomas Lincoln came, it is believed, into the neighborhood to visit his brother Mordicai, who lived near Major Berry, and there learned of the skill of Nancy.")]), _vm._v(" "), _c('p', {
    staticClass: "quoteib"
  }, [_vm._v("As Ulysses, he was ambitious and became the husband of Nancy, whose thread of gold has been woven into the warp and woof of the National Constitution.")])]), _c('p', {
    staticClass: "indentb"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Once married, Thomas and Nancy settled at Mill Creek, where their first child, Sarah, was born. They then moved on to Sinking Spring Farm near Hodgenville, so called because of the spring that bubbled up from the bottom of a deep cave. The spring still bubbles inside a cool cavern, but the home must have been a disappointment to Nancy. We’re only saying this based upon our own materialistic values, but really, does any gal desire a place with a glassless window covered in greased paper or by a thin piece of animal skin and a single door to the outside attached by leather hinges? Oh, and need I add that the floor was hard-packed dirt?")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("HODGENVILLE, KENTUCKY: LINCOLN’S BIRTHPLACE")])]), _vm._v(" "), _c('p', {
    staticClass: "quote"
  }, [_vm._v("I was born February 12, 1809, in then Hardin County, Kentucky, at a point within the now county of Larue, a mile or a mile and a half from where Hodgen’s mill now is. My parents being dead, and my memory not serving, I know no means of identifying the precise locality. It was on Nolen Creek.")]), _vm._v(" "), _c('p', {
    staticClass: "quotei"
  }, [_vm._v("A. Lincoln.")]), _vm._v(" "), _c('p', {
    staticClass: "quoteib"
  }, [_vm._v("June 14, 1860.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("After Lincoln’s death, historians discovered the land where he had been born, and, like the ever-moving Lincoln family, a re-created cabin said to be his birth cabin, too, hit the road. Disassembled, the logs were shipped to Chicago, reconstructed, and exhibited at the World’s Columbian Exposition in 1893 before going on tour throughout the United States.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("When the tour was over, the logs were returned to their original site, put back together, and then encased in an outer building made of marble, ensuring that the cabin would withstand the ages. It is now part of the 116-acre Abraham Lincoln Birthplace National Historical Park in Hodgenville, about thirty-seven miles west of Springfield—more than a long day’s travel back ")]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("in the day of Tom and Nancy but just over thirty minutes for me.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "indentb"
  }, [_vm._v("The sixteen-by-eighteen-foot cabin was built from about 143 oak and chestnut logs chinked together with clay. The roof was covered with rough wooden shingles and had a small, box-like stick-and-clay chimney. Other amenities, as today’s real estate ads say, included a stone fireplace. Little of the surrounding landscape has changed from when the Lincolns lived there, and park activities are designed to let visitors view and experience the hard chores of pioneer life, including rail splitting. Life-sized bronze statues of the family are poised at the entrance of the park’s museum.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("KNOB CREEK, KENTUCKY: LINCOLN’S BOYHOOD HOME")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tom and Nancy had worked hard to buy Sinking Spring Farm, but because of Kentucky’s then byzantine land-title problems, they lost the land and the family was forced to hit the road again, moving on in 1811 to what is now Abraham Lincoln’s Boyhood Home at Knob Creek, just northeast of Hodgenville. This is easily reached by taking Kentucky 210 north into Hodgenville and then following US 31 east. Lincoln was two and a half at the time of the move, and in a widely quoted 1860 letter to Samuel Haycraft of Elizabethtown, he wrote “My earliest recollection is of the Knob Creek place.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nancy had her last child, named Thomas, at the Knob Creek farm; sadly he died shortly after birth. Sarah and Abe attended a subscription school in the area (Kentucky didn’t have public schools until 1830). Kentucky Historical Marker #1482 identifies the approximate site of Abraham Lincoln’s first school, a very short drive from Knob Creek now, but the two Lincoln children had to make their way through a heavily forested area. The marker reads as follows:")])]), _c('div', {
    staticClass: "figure"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg22_1.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "figcaption"
  }, [_vm._v("The Memorial Building at the Abraham Lincoln Birthplace National Park was built in 1909–1911 on the site where Lincoln was born and houses a “symbolic” Lincoln birth cabin. "), _c('i', [_vm._v("Photo courtesy of Wikimedia")])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('b', [_vm._v("Abraham Lincoln’s First School")])]), _vm._v(" "), _c('p', {
    staticClass: "quoteb"
  }, [_vm._v("Lincoln’s formal education began in a primitive log cabin near this site. While the Lincoln family was living on Knob Creek, he and his sister Sarah attended ABC schools for a short period of time. The first school was taught by Zachariah Riney; the second by Caleb Hazel. The Lincolns’ home stood two miles south on the old Cumberland Road.")])]), _c('p', {
    staticClass: "indentb"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("It was here at Knob Creek that Lincoln first saw slavery up close when he spied African-Americans being marched south along the Bardstown–Green River Turnpike, part of the old Cumberland Road, to be sold as slaves. When Abe was seven, in ")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("1816, the Lincolns lost a legal battle against a consortium who claimed they owned ten thousand acres (including the Lincolns’ thirty acres) in Knob Creek, and the family was forced to move on again.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("ELIZABETHTOWN, KENTUCKY")])]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Bathsheba’s Later Years")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("While her children were moving and raising families, Lincoln’s paternal grandmother, Bathsheba, had eventually settled in Elizabethtown, a charming city just twenty-one miles from Abraham Lincoln’s Boyhood Home at Knob Creek via KY 210. Her home is gone, but the mantelpiece is on display at the Lincoln Room of the Fort Knox Saber & Quill, a dining room open to the public in Elizabethtown. As was unfortunately common back then, only two of Bathsheba’s children would survive her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mord’s death was reflective of the pioneer life and just as atypical of how people die today as his father being shot by an Indian. Mordecai and his family, including four of his children, had moved from Kentucky to Fountain Park (now Fountain Green), Illinois, in 1828. In December 1830, a blizzard roared through the region while Mordecai was away from home, and although his horse returned to the family homestead, Mord did not. Whether he fell and couldn’t get back on his horse and froze to death, or whether he had a heart attack or some other injury that kept him from staying in the saddle and riding home was never determined. Twenty feet of snow covered Mordecai’s body, and it wasn’t discovered until the spring thaw the following April.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Bathsheba’s daughter Mary Ada Lincoln was first the common-law wife of Daniel Edgar Crume, who died in 1824. Their relationship is described as beginning after the death of Daniel’s first wife around 1791 and ending before 1801. The couple had two daughters, both of whom died before 1880. In 1801, Mary ")]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("married Ralph Crume, who was Daniel Crume’s nephew, and they had three children. Mary Lincoln Crume is believed to have died between 1830 and 1832 and is buried in the Crume family cemetery in Crume Valley, Breckinridge County, Kentucky.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("By 1835, Bathsheba’s son Josiah was also dead. Her daughter Nancy would live until 1843. It was Thomas who lived the longest, dying in 1851. When she died in 1836, Bathsheba wasn’t buried with her husband, and like her husband, her gravesite fell into disrepair.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("On February 15, 1931, the "), _c('i', [_vm._v("Courier Journal")]), _vm._v(" published a photo showing several tottering tombstones in a neglected cemetery overgrown with weeds and shrubs. The photo was accompanied by the following caption.")]), _vm._v(" "), _c('p', {
    staticClass: "quoteb"
  }, [_vm._v("The small neglected stone at the right is the grave of Bathsheba Lincoln, the grandmother of President Lincoln, and the two at the left are those of Mary Brumfield Crume and (her mother) Nancy Lincoln Brumfield (far left), resp. first cousin and aunt of President Lincoln.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("That article spurred action, and Bathsheba’s gravesite and that of her daughter Nancy Lincoln Brumfield are now located at Fort Knox in an area not open to the public.")])]), _c('p', {
    staticClass: "indentb"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("The history of the Civil War is even more closely entwined with the history of the Lincolns than with most families of that era, and the convergence of the events of the war and of the family is evident everywhere in and around Elizabethtown, the seat of Hardin County. Fort Knox is Kentucky’s largest and best preserved earthen Civil War fort, and costumed interpreters there host living-history and reenactment events throughout the year. The Hardin County History Museum has collected an amazing amount of material associated with Fort Sands, Fort Boyle, and Fort Duffield—all Civil War forts located within the county. These include training manuals, photos, and a telegraph dispatch from President Lincoln to Union general Rousseau while Rousseau was stationed at Camp Nevin, a training camp ")]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("in Nolin, south of Elizabethtown, that housed approximately fifteen thousand troops between October 1861 and January 1862.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("The Lincoln Museum and Boundary Oak Distillery")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In Kentucky, both bourbon and history are always in play, and at the Boundary Oak Distillery in Radcliff, just northeast of Elizabethtown, master distiller Brent Goodin covered these two basics when he created Lincoln Spirits. This limited-edition bourbon uses corks made from the Boundary Oak tree, which was used as one of the boundary markers on the farm where Lincoln was born and is thought to have been the last living link to Lincoln when it died in 1976. It was quite the tree too—standing ninety feet high, with a trunk diameter of six feet and a crown spread of one hundred and fifteen feet. Boundary Oak Distillery obtained some of the wood, but most of it was preserved by the Lincoln Museum in the Hodgenville National Historic District. Boundary Oak wood from the museum has been used to make gavels distributed to dignitaries from Supreme Court justices to state governors and foreign leaders. Featuring period artifacts, a series of dioramas of Lincoln’s life, and a collection of wax figures of historic people, the Lincoln Museum is three miles north of the Abraham Lincoln Birthplace National Historical Park and seven miles west of Lincoln’s Boyhood Home at Knob Creek.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As for the bourbon, Boundary Oak’s Lincoln Spirits is not to be taken lightly. At an auction for the first bottle, held before it was even ready to be released, the top bid was over $28,000, the highest price ever paid for a bottle of American whiskey. When you buy a bottle, you also get a copy of Lincoln’s liquor license (he is the only president to have had one).")])]), _c('p', {
    staticClass: "indentb"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("In another interesting tie-in with history, a relative of distillery owner Brent Goodin established a fort at what is now Bardstown, where you can also find the Women’s Civil War Museum and Old Bardstown Village and Civil War Museum. If you’re already visiting Bardstown, it’s only twenty-four miles on ")]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("KY 62/Lincoln Parkway and Patriot Parkway to get to Radcliff to sample some bourbons—and no, there won’t be any free samples of Lincoln Spirits.")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Wanted: A New Wife")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("After losing their home on Knob Creek, Nancy and Thomas moved to Indiana, settling on Little Pigeon Creek. In 1818 Nancy died, and Thomas, needing another wife, returned to Elizabethtown and proposed marriage to Sarah Bush Johnston. He’d pursued her before marrying Nancy, but she had turned him down and married Daniel Johnston instead.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("One of nine children born into a prosperous family, Sarah was fond of the latest styles and had blue-gray eyes and a light complexion. She was described as proud, energetic, hard-working, neat, and possessing good sense. Though she supposedly declined Thomas because she didn’t think he’d amount to much, Daniel wasn’t much of a winner either, and his brothers often had to pay his debts. Then Sarah and Daniel’s luck seemed to change. He got a job as the county jailer, and the family, as was common back then, lived in the jailhouse, where Sarah did the cooking and cleaning. She and Daniel also cleaned the courthouse, another source of income. But then misfortune struck, and in 1816 Daniel died of cholera. By 1819, when Thomas came to town, Sarah seemed to be prospering—she owned a cabin filled with good furniture, and one of her daughters was attending a private school. Tom had hit pay dirt. The story of their brief courtship was told to a correspondent for the "), _c('i', [_vm._v("Atlantic")]), _vm._v(" by a physician in Jasper, Arkansas—a son of one of Lincoln’s nieces who had been raised in Tom and Nancy’s home:")])]), _c('p', {
    staticClass: "quoteb"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Thomas Lincoln made a short trip to Kentucky, and while there married a widow, a Mrs. Johnston. “Mother said she was his old sweetheart, before he ever saw Nancy Hanks,” related the doctor. “When he went back, I guess he had her in view. When he got there, she was washing in the yard. He went along just like he was walking by and leant up against the fence and talked to her. He proposed marriage, and she said, ‘I owe too much.’ ‘How ")]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("much?’ Uncle Tom asked her, and she replied, ‘Two dollars and a half.’ Uncle Tom volunteered, ‘If that’s all, I’ll pay that’; and the match was made up right there. I’ve heard mother laughing about that many a time.” (Arthur E. Morgan, “New Light on Lincoln’s Boyhood”)")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("While Mrs. Johnston was lacking in ready money, yet according to the doctor, “She was right good for property. She had right smart.” And Uncle Tom brought back not only a wife, but a wagonload of her furniture.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Sarah had three young children, so besides organizing the Lincolns, she brought new life into the isolated family. A copy of the marriage bond between Thomas and Sarah is at the Hardin County Public Library in Elizabethtown. A replica of the cabin where Sarah Bush Johnston and her three children were living when Thomas came courting is located at Freeman Lake Park. It’s a pretty scene, but, I warn you, after a while all these log cabins begin to look the same—there seems to have been only one basic model with occasional upgrades, as realtors today would call them, such as a loft or second floor, or maybe even a passageway where a horse and wagon could be stowed between the kitchen area and the bedrooms. Having a horse or two nearly inside probably didn’t make much difference when it came to odors. After all, those cabins brimmed with unbathed people, chamber pots, and dirty clothes. Sarah, though, was not the average woman, and history says she cleaned up Thomas’s cabin and his kids. She was that kind of person.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Other Traces of Lincoln")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In downtown Elizabethtown, a cabinet made by Thomas Lincoln is on display at the Brown-Pusey House. The home was built in 1825 and is considered one of the best examples of rural Federal architecture in the town. It also boasts an extensive and well-respected research library and a lovely garden.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are other Lincoln associations with the Brown-Pusey House as well, some tangential, but all connecting dots between the Civil War, the Lincoln family, and the people and places who defined the times. Confederate General John Hunt Morgan, whose life intersected with Thomas’s brother Josiah Lincoln’s, dined there several times. Morgan—a dashing and impetuous soldier known for his fondness for good wine, good food, pretty women, and a comfortable bed (not for him the hardships of a soldier’s life)—hailed from Lexington, and his family home, now a house museum, is within walking distance of Mary Todd Lincoln’s home, also a museum, and the law offices of Henry Clay, at one time a great hero to Lincoln. General George Custer and his wife would move into the Brown-Pusey Home much later, after Custer was sent to help control the rise of the Ku Klux Klan. There’s no connection to Lincoln in the case of Custer, but it is an interesting factoid.")])]), _c('div', {
    staticClass: "figure"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg28_1.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "figcaption"
  }, [_vm._v("A cabinet made by Thomas Lincoln, a skilled carpenter, is on display at the Brown-Pusey House, in Elizabethtown. "), _c('i', [_vm._v("Photo courtesy of Wikimedia")])]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Sisters-in-Law from Hell")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("The Elizabethtown Historic Driving Tour includes many late-eighteenth-century sites and further Lincoln connections. ")]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("For example, the McKinney-Helm House, circa 1820, at 218 West Poplar Street, was at one time owned by Emilie Todd Helm, half-sister of Mary Todd Lincoln and widow of Confederate general Ben Hardin Helm. Emilie was pretty, pert, and seemingly spoiled, with a bio that reads like that of Scarlett O’Hara in "), _c('i', [_vm._v("Gone with the Wind")]), _vm._v(". Like many of Mary’s half-siblings, the children of Mary’s father and her despised stepmother, Emilie was a true, die-hard Confederate. Her husband declined a job as an army paymaster when President Lincoln offered it to him and instead joined the Confederate Army. That didn’t work out too well for him—he was only thirty-two when he died in the awful Battle of Chickamauga in 1863. His death was an emotional blow for both Mary and Abe. In December of that year, Emilie and her daughter came to stay for a time at the White House. Lincoln was criticized for having her there and reportedly defended his decision by saying, “Mrs. Lincoln and I will allow anyone we choose to visit us in the White House.”")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "indentb"
  }, [_vm._v("In her diary Emilie wrote,")]), _vm._v(" "), _c('p', {
    staticClass: "quote"
  }, [_vm._v("Mr. Lincoln in the intimate talks we had was very much affected over the misfortunes of our family; and of my husband he said, “You know, Little Sister, I tried to have Ben come with me. I hope you do not feel any bitterness or that I am in any way to blame for all this sorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "quoteib"
  }, [_vm._v("I answered it was “the fortune of war” and that while my husband loved him and had been deeply grateful to him for his generous offer to make him an officer in the Federal Army, he had to follow his conscience and that for weal or woe he felt he must side with his own people. Mr. Lincoln put his arms around me and we both wept. (Katherine Helm, "), _c('i', [_vm._v("The True Story of Mary, Wife of Lincoln")]), _vm._v(", 233)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But the Lincoln’s kindness toward Emilie started wearing thin. In the summer of 1864, Lincoln had her brought to the White House because she refused, when detained at Fort Monroe in Virginia, to vow loyalty to the Union.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("In a diary entry about this forced visit, Emilie wrote,")])]), _c('p', {
    staticClass: "quoteb"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Mr. Lincoln and my sister met me with the warmest affection, we were all too grief-stricken at first for speech. I have lost my husband, they have lost their fine little son Willie. Mary and I have lost three brothers in the Confederate service. We could only embrace each other in silence and tears. Our tears gathered silently and fell unheeded as with choking voices we tried to talk of immaterial things. (Helm, "), _c('i', [_vm._v("The True Story")]), _vm._v(", 221–22)")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Emilie was quite bold about her Confederate loyalties, especially given she was staying at the White House over many people’s objections, some of whom called her “The Rebel.” Despite their shared grief, she fought with Mary over who the real president of the country was. Mary, of course, said it was her husband. Emilie said no, it was Jefferson Davis.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Emilie’s tongue was tart and her manner arrogant. When a US senator said to her, “We have whipped the rebels at Chattanooga, and I hear the scoundrels ran like scared rabbits,” she was quick with her reply. “It was the example you set them at Bull Run and Manassas.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She did finally take an oath of allegiance but continued to support Confederate causes. In August 1864, Lincoln had finally had enough and wrote General Stephen G. Burbridge stating that he was not giving Emilie any protection against prosecution for her actions: “If the paper given her by me can be construed to give her protection for such words so, it is hereby revoked "), _c('i', [_vm._v("pro tanto")]), _vm._v(". Deal with her for current conduct, just as you would any other” (Roy P. Basler, "), _c('i', [_vm._v("Collected Works of Abraham Lincoln")]), _vm._v(", 485).")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Do you think that stopped Emilie from asking for favors? If you said yes, you need to go rent a copy of "), _c('i', [_vm._v("Gone with the Wind")]), _vm._v(". Like Scarlet O’Hara, Emilie seems to have had an immense sense of entitlement. We don’t know if she stamped her feet like Scarlet did, but in November she asked for another pass to sell her cotton, writing to Lincoln in a somewhat waspish tone, “I have been a quiet citizen and request only the right which humanity and justice always gives to widows and orphans. I also would remind you that your minié bullets have made us what we are” (Ruth Painter Randall, "), _c('i', [_vm._v("Mary Todd Lincoln")]), _vm._v(") She seemed ")]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("to be missing the point that the Union had widows and orphans made so by Confederate bullets. And besides, who had started the damn war?")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Emilie never remarried, wearing widow’s weeds for the remainder of her life. She died at age ninety-three and is buried in the Lexington Cemetery, along with so many of Mary Todd’s family and friends and those who intersected with the Lincolns, including John Hunt Morgan.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Martha Todd White, another of Mary Lincoln’s half-sisters, was also a gung-ho supporter of the Confederacy. Because of her family connection she received a pass to come north, but despite her requests for an invitation to the White House, her Confederate sympathies were such that she was denied. Lincoln finally threatened that if she didn’t leave DC immediately she’d be confined to the Old Capitol Prison. She took the hint and left, but she returned later wanting a permit to export cotton to the north, a move that would help bolster the Confederate economy as well as her own pocketbook. Lincoln was not about to let happen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bright, pretty, and popular, Mary smuggled “almost her weight in quinine” through the lines for sick Southern soldiers. The result was less quinine for sick Union men. It’s said she bragged about how she outwitted her “brother Lincoln.”")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Relatives, right? What are you going to do?")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("HARRODSBURG, KENTUCKY")])]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Pleasant Hill: The Original Peaceniks")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Northeast of Elizabethtown are remnants of Shaker communities that were thriving in Lincoln’s time. Lincoln would have been well aware of the Shakers, at that time a dominant force offering an appealing ideal of communal living. Ahead of their time in many ways, members of United Society of Believers in Christ’s Second Appearance, called Shakers because of their ecstatic movements during prayer, abolished slavery among their own and bought slaves for the purpose of freeing them. In 1817, they granted women equal rights—a century or more before all women in the United States would be allowed to vote. They also, rather amazingly, let women hold positions of power in their community. Their industriousness brought them prosperity.")])]), _c('div', {
    staticClass: "figure"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg32_1.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "figcaption"
  }, [_vm._v("A horse and wagon travels along a road lined with buildings dating back to the early 1800s. Shaker Village of Pleasant Hill is America’s largest restored Shaker village. "), _c('i', [_vm._v("Photo courtesy of Jane Simon Ammeson")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Though Lincoln never visited either of the Shaker villages in Kentucky, the Shakers’ abolitionist views were in sync with his own and a number of Shaker communities are located near sites where Lincoln lived. Dating back to the early 1800s, Shaker Village of Pleasant Hill just outside of Harrodsburg was once the third largest Shaker community in the United States and it is now one of only a few Shaker settlements with buildings still standing. And though the Shakers who lived here and in South Union Shaker Village in Auburn, Kentucky, are gone, historic preservationists are dedicated to retaining the charm of these historic sites by immaculately restoring the buildings and showcasing how life was lived in one of the most successful utopian communities in American history.")])]), _c('div', {
    staticClass: "figure"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg33_1.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "figcaption"
  }, [_vm._v("The Kentucky River was a source of livelihood for the Shakers. The same landing used by the Shakers is now the launching point of the "), _c('i', [_vm._v("Dixie Belle")]), _vm._v(", Shaker Village’s paddlewheeler, and is also one of the few public access points to the beautiful Kentucky River Palisades. "), _c('i', [_vm._v("Photo courtesy of Jane Simon Ammeson")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pleasant Hill, approximately eighty miles from Elizabethtown via Martha Layne Collins Blue Grass Parkway East to US 127 South, is the only national historic landmark where visitors can spend the night in the same rooms Shakers lived and worked in. The winding roads in the area lead through small, quaint, charming towns. A few miles from the entrance to Pleasant Hill a narrow road winds down a steep hillside to the dock of the "), _c('i', [_vm._v("Dixie Belle")]), _vm._v(" riverboat, where up to 115 visitors can take a one-hour cruise through the soaring palisades of this largely undeveloped section of the Kentucky River. The tour guide explains how important transportation was for the community, which sold its goods as far south as New Orleans.")])]), _c('div', {
    staticClass: "figure"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg34_1.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "figcaption"
  }, [_vm._v("A landmark destination located in Harrodsburg, the three-thousand-acre Shaker Village of Pleasant Hill was home to the third largest Shaker population in the United States. The Shakers were among the earliest abolitionists and also believed in equal rights for women. "), _c('i', [_vm._v("Photo courtesy of Jane Simon Ammeson")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Preserving the uniqueness of the Shakers’ heritage is part of the mission of both South Union Shaker Village and Pleasant Hill. In 1840 around six thousand Shakers lived in nineteen communal villages in New England, Indiana, Ohio, and Kentucky. Only one remains today, its membership down to two. But the ideals of pacifism, communal living, taking care of each other, and focusing on spirituality rather than worldly goods still seem worthy goals.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the Kentucky River, Shaker Hill of Pleasant Village is near where the Civil War Battle of Perryville took place, and many of the wounded were brought there for care. “The Shakers took in anyone, whether they were Union or Confederate, who needed tending,” says Aaron Genton, collections manager at Pleasant Hill, which is located just outside of Harrodsburg, the oldest city in Kentucky. “But they were certainly in support of the Union and Lincoln’s policies.”")])]), _c('div', {
    staticClass: "figure"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg35_1.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "figcaption"
  }, [_vm._v("Thomas Lincoln and Nancy Hanks were married in a log cabin belonging to Richard Berry in the small hamlet of Beachland near Springfield on June 12, 1806. That cabin is now protected from the elements by a brick museum at the Lincoln Marriage Temple in Harrodsburg. "), _c('i', [_vm._v("Photo courtesy of Jane Simon Ammeson")])])]), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('b', [_vm._v("The Lincoln Marriage Temple")])])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "noindentb"
  }, [_vm._v("The Lincoln Marriage Temple in Harrodsburg, a stop on Kentucky’s Lincoln Heritage Trail, is an odd-sounding name (maybe a little too Las Vegas–like?), but the intent to honor the Lincolns is real. The red brick building encasing the log cabin where Tom and Nancy got married is part of the Old Fort Harrod State Park in downtown Harrodsburg. Also part of the park are the historic Mansion Museum, the George Rogers Clark Federal Monument, and the oldest cemetery west of the Alleghenies.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Kentucky Owl")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Bourbon and Lincoln history again cross paths in Harrodsburg. The stately Beaumont Inn was built in 1825 and functioned as a school for girls before being bought by the Dedman family in 1917, who have operated it as an inn ever since. The James Beard Award–winning dining room is just one part of what makes this a great stop for anyone visiting Harrodsburg. Dixon Dedman, who owns the inn along with his parents, is also famed for his bourbon tastings and his revival of the bourbon his great-great-grandfather used to make before Prohibition shut him down.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dedman is the creator of Kentucky Owl distillery, where he makes small batches of his limited-release and top-rated Kentucky Owl rye whiskey. “It’s an 11-year-old Kentucky Straight Rye Whiskey and it’s exactly what a Rye Whiskey should be,” Dixon writes on Kentucky Owl’s Facebook page about his most recent batch. “I put this blend together and bottled it at 110.6 proof. It’s a full-flavored rye perfect for the coming fall weather.”")])]), _c('p', {
    staticClass: "indentb"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("Barrel aging can produce bourbons with a high proof, but before they’re bottled, they’re watered down to around 80 proof. ")]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("Dixon wasn’t about to do that to Kentucky Owl. “It’s full flavored,” he said about this batch of Kentucky Owl, and it sure was. “You can’t hide anything in barrel proofed whiskeys.”")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("SHELBYVILLE, KENTUCKY")])]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("The Boones and Painted Stone Station")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Because the Boones and the Lincolns were interconnected, I thought I’d segue into a little Boone family history here. Squire Boone, the brother of the more famous Daniel, was also an explorer and woodsman and famed in his day for his exploits in opening up Indiana and Kentucky to settlers. Back then both states were wild, dangerous, and unexplored. Of the first eight white men to enter Kentucky, Squire and Daniel were the only two to come out alive—and it was Squire who rescued Daniel. The two were said to be such excellent trackers that they could agree to meet at a certain time on a certain day and each take a separate route into the wilderness—returning at the exact time and place they’d agreed on. No GPS needed for these guys.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Ten years younger than Daniel but filled with the same wanderlust, Squire Boone established Painted Stone Station in 1780, the first settlement in Shelby County, about fifteen miles from the Old Stone Inn. It was the only station between Harrodsburg and what is now Louisville. The nearest station at the time was Linn’s, twenty-one miles distant, which even on a fast horse would take two hours or more to reach. So even if someone managed to escape under siege, help couldn’t be expected to arrive for at least four or five hours. A battle could very well be finished by then. At its peak, one hundred people lived at Painted Stone Station; unfortunately, it didn’t work out well for them.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Painted Stone Is Attacked: The Long Run Massacre")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("In April of 1781, Boone’s Station came under attack and the alarm was sounded, Squire Boone, in his shirttails, and about a ")]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("dozen other men seized their guns and ran to its defense, where they were waylaid by about twenty Indians. Boone, covering the retreat of his comrades, received two gunshot wounds—one breaking his right arm just below the elbow, and the other hitting him in his right side. Despite his serious injuries he was still able to make it back inside the stockade.")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The leader of the attack was Simon Girty, a notorious renegade who had been captured by the Seneca Indians in his youth and adopted into the tribe. In 1778, after going over to the British, he had served as scout and interpreter. He would be present when Colonel William Crawford was tortured and burned at the stake in 1782 in retaliation for the brutal massacre of ninety-six peaceful Christian Indian men, women, and children who had been slaughtered by Pennsylvanian militiamen, although Colonel Crawford had not been among them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Girty would later boast that he had made Squire Boone’s white shirt fly with his shots. For a while there was concern Boone wouldn’t survive, but he recovered in about three months. Though his arm healed, it was about an inch and a half shorter than it had been, and a long while after the battle, splinters of bone would work their way out of his skin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That wasn’t the end of it. Learning they were going to be attacked again that September, some of the settlers at Painted Stone Station (named after a stone Squire had decorated to mark the place) fled for a safer station, and some were killed before they made it. Squire Boone and his family, along with one other family, remained at the station and were rescued a few days later. Squire returned two years later to find Painted Stone Station had been burned to the ground. He stayed to rebuild it, and even added a gristmill.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Though unknown to many Americans, the story of Painted Stone Station is very well known in Shelby County. For over twenty years, there’s been an annual reenactment of the events known as the Long Run Massacre and Floyd’s Defeat, held the second full weekend in September at Red Orchard Park in Shelbyville, which is just a few miles from the Old Stone Inn and Captain Abraham Lincoln’s gravesite.")])]), _c('div', {
    staticClass: "figure"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pg39_1.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "figcaption"
  }, [_vm._v("Autumn Nethery, distiller and co-owner of Jeptha Creed distillery, stands in front of some of their products. Jeptha Creed is distilled from grain grown on Jeptha Knob, named by Daniel and Squire Boone. "), _c('i', [_vm._v("Photo courtesy of Jane Simon Ammeson")])]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Like Tom Lincoln, Squire too had land disputes (Kentucky was notorious for that) and also, according to contemporary accounts, liked to gamble too much, which led to his losing much of his land and money.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('b', [_vm._v("Jeptha Creed Distillery")])])]), _c('p', {
    staticClass: "noindentb"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("As you know, I always seem to have bourbon on my mind, so I’ll mention that the recently opened Jeptha Creed Distillery in Shelbyville is on land near where Painted Rock most likely stood. Jeptha Creed is owned by the Nethery family, and the moonshine, vodka, and bourbon they distill is made from the open-pollinated, non-GMO, heirloom Bloody Butcher corn they’ve been growing since 1845 on their Jeptha Knob farm, located about six miles from the distillery. And here’s the tie-in ")]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("with Daniel and Squire: the Boone brothers are the ones who named the land back in the late 1700s after the biblical warrior and judge Jephthah. Isn’t that a good enough reason to stop by for a taste?")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("PIONEER STOCK: THE BOONES")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("We’d be remiss not to share some more about the Boone family, as their history reflects the times they lived in, giving us another window into the life of early pioneer families, including the Lincolns. George Boone, who was born about 1670 at his old family home eight miles from Exeter, England, arrived with his wife, Mary, and the couple’s eleven children (nine sons and two daughters) in Philadelphia on October 10, 1717. Purchasing a tract of land in what is now Berks County, Pennsylvania, Boone named it Exeter after his hometown in England. One of George and Mary’s sons, Squire, married Sarah Morgan on July 23, 1720. They also had eleven children, seven boys and four girls. Their oldest boy, James, was killed by Indians.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("Sarah and Squire’s son Daniel was born October 22, 1734. He was described as having a restless pioneer spirit; a chronicler writes that Daniel “early began his adventurous travels, although he had a good education for the times, and was a skilled land surveyor” (State Historical Society of Missouri, “Lincoln, Hanks and Boone Families”). Daniel married Rebecca Bryant on August 14, 1756, when he was twenty and she was seventeen, after a three-year courtship. During a twenty-nine-year period, Rebecca had six sons and four daughters, which is pretty remarkable in itself, and even more so considering Daniel was often away on long trips. Not only did they have their own large brood, Daniel and Rebecca also took in a large number of children who had been orphaned (a very common occurrence back then). Right before the birth of Rebecca’s ninth child, she welcomed her widowed uncle’s six children, ranging in age from ")]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("six to sixteen. Described as tall and very pretty, Rebecca was also the midwife and the family healer for the communities she lived in, as well as a leather tanner, sharpshooter, and linen maker. How she had time for all this, we don’t know. All I can say is, “Go, Rebecca, go.”")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("To make it more complicated—and isn’t that just typical of life—it’s said that on one of Daniel’s many long expeditions (this one lasted two years), Rebecca, believing he was dead, dallied with Daniel’s brother Edward and became pregnant. Though that made things a little dicey between the two brothers, Daniel accepted his brother’s daughter, who was named Jemima, as his own. We don’t know if Jemima knew that her father was really her uncle and her uncle her father. Even more soap opera–ish, Edward was married to Rebecca’s sister Martha, and the couple had six children. Poor Neddy, as he was called, was said to be a kindly and affable guy who stayed behind when Daniel and the others went exploring to take care of community matters.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Neddy came to an unfortunate end when on a hunting trip with his brother. The two men were returning from a trip to the Blue Licks when they stopped along a stream in Bourbon County near Paris. There Edward rested underneath a buckeye tree, cracking nuts and watching the horses as they drank. Daniel, who was in the woods hunting game, heard shots being fired by Indians and hid until they left. Stories diverge here. Some say Daniel returned to find Edward riddled with seven musket balls. Another version says he ran on foot to Boone Station, where he and his brother and about fifteen other families were living. The following morning, Daniel and a group of men went in search of the Indians but they were gone. Finding Edward’s body, they buried him where he died, near the old buckeye tree. The creek where Edward met his end was named Boone Creek in his honor.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("By 1827, rain and erosion had exposed Edward’s bones, and he was reinterred about a mile away. When his gravesite fell into disrepair, it was restored, and the Edward Boone Death Site was designated a Kentucky Landmark by the Kentucky Heritage ")]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("Council. Later, a Kentucky Historical Highway Marker was established at KY Highway 537 and See Road, about a mile east of Little Rock.")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Daniel and Rebecca spent the last years of their fifty-eight years of marriage (imagine that) living with Jemima and Flanders Callaway, their son-in-law. Rebecca died in 1813 at age seventy-five; Daniel lived until the age of eighty-five, dying in 1820. They are now buried in Frankfort Cemetery in Frankfort, Kentucky.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Boones and Callaways had been friends for many years, going back to when Jemima Boone and Fanny and Betsey Callaway, fourteen-year-old girls who lived at Boonesborough, Kentucky, were captured while canoeing on the Kentucky River by a war party of three Shawnee men and two Cherokee men, led by the Cherokee Hanging Maw. Native American tribes like the Shawnee frequently attacked Kentucky settlements in attempts to drive out the people they saw as stealing their land. The attacks became so violent that by late spring of 1776, fewer than two hundred settlers remained, and those who did mostly lived in the fortified stations at Boonesborough, Harrodsburg, and Logan’s Station.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fanny and Betsey were the daughters of Colonel Richard Callaway, who, along with his son Flanders, joined Daniel Boone in a search party. The Indians were taking the girls north toward their towns, and as they moved, the girls tried to leave a trail to be followed. Although their captors made them stop, the search party was still able to sneak up on them. As a shot rang out, injuring one of the Indians, Jemima supposedly shouted, “That’s Daddy’s gun.” What can I say? It’s a good daughter who knows the sound of her father’s gun.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When asked by their rescuers if they were okay, Jemima replied, like a true Boone, that the Indians had been kind to them, “as much so as they well could have been, or their circumstances permitted.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("It isn’t known if the rescue added to their romance, but the three girls each married one of the rescuers. A month after their escape, Elizabeth Callaway married Samuel Henderson. The following year, Jemima married Flanders Callaway, and Fanny Callaway married Colonel John Holder. The story of the kidnapping and rescue was the basis for the novel and the movie "), _c('i', [_vm._v("The Last of the Mohicans")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('p', {
    staticClass: "indentb"
  }, [_vm._v("In a sad aside, Jemima and Flanders’s oldest son, James Callaway, would be shot and killed by Indians. Callaway County in Missouri is named after him, and a war memorial located in Fulton, Missouri, was erected in his honor. Two of Jemima’s brothers, James and Israel, were also killed by Indians. John Stewart, Jemima’s uncle and the husband of Daniel’s sister Hannah, died the same way.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("PLACES TO VISIT")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('b', [_vm._v("Abraham Lincoln Birthplace National Historical Park")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("2995 Lincoln Farm Road")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Hodgenville, KY")])]), _c('p', {
    staticClass: "noindentsb"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("(270) 358-3137; ")]), _c('a', {
    attrs: {
      "href": "http://nps.gov/abli/index.htm",
      "target": "_blank"
    }
  }, [_vm._v("nps.gov/abli/index.htm")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('b', [_vm._v("Abraham Lincoln’s Boyhood Home at Knob Creek")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("7120 Bardstown Road")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Hodgenville, KY")]), _vm._v(" "), _c('p', {
    staticClass: "noindentsb"
  }, [_vm._v("(270) 358-3137; "), _c('a', {
    attrs: {
      "href": "http://nps.gov/abli/planyourvisit/boyhood-home.htm",
      "target": "_blank"
    }
  }, [_vm._v("nps.gov/abli/planyourvisit/boyhood-home.htm")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('b', [_vm._v("Beaumont Inn")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("638 Beaumont Inn Drive")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Harrodsburg, KY")]), _vm._v(" "), _c('p', {
    staticClass: "noindentsb"
  }, [_vm._v("(859) 734-3381; "), _c('a', {
    attrs: {
      "href": "http://beaumontinn.com",
      "target": "_blank"
    }
  }, [_vm._v("beaumontinn.com")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('b', [_vm._v("Boone Station Historical Site")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("240 Gentry Road")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Athens, KY")]), _vm._v(" "), _c('p', {
    staticClass: "noindentsb"
  }, [_vm._v("(859) 263-1073")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('b', [_vm._v("Boundary Oak Distillery")])])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('p', {
    staticClass: "noindents"
  }, [_vm._v("2000 Boundary Oak Drive")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Radcliff, KY")])]), _c('p', {
    staticClass: "noindentsb"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("(270) 351-2013; ")]), _c('a', {
    attrs: {
      "href": "http://BoundaryOakDistillery.com",
      "target": "_blank"
    }
  }, [_vm._v("BoundaryOakDistillery.com")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('b', [_vm._v("Brown-Pusey House")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("128 North Main Street")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Elizabethtown, KY")]), _vm._v(" "), _c('p', {
    staticClass: "noindentsb"
  }, [_vm._v("(270) 765-2515; "), _c('a', {
    attrs: {
      "href": "http://brownpuseyhouse.org",
      "target": "_blank"
    }
  }, [_vm._v("brownpuseyhouse.org")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('b', [_vm._v("Captain Abraham Lincoln’s Gravesite")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Long Run Cemetery")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Old Stage Coach Road")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Eastwood")]), _vm._v(" "), _c('p', {
    staticClass: "noindentsb"
  }, [_vm._v("Jefferson County, KY")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('b', [_vm._v("Edward Boone Death Site")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("KY Highway 537 and See Road, about a mile east of Little Rock")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Eleanor Hamilton’s Old Stone Inn")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("6905 Shelbyville Road")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Simpsonville, KY")]), _vm._v(" "), _c('p', {
    staticClass: "noindentsb"
  }, [_vm._v("(502) 722-8200; "), _c('a', {
    attrs: {
      "href": "http://eholdstoneinn.com",
      "target": "_blank"
    }
  }, [_vm._v("eholdstoneinn.com")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('b', [_vm._v("Fort Boonesborough State Park")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("4375 Boonesboro Road")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Richmond, KY")]), _vm._v(" "), _c('p', {
    staticClass: "noindentsb"
  }, [_vm._v("(859) 527-3131; "), _c('a', {
    attrs: {
      "href": "http://parks.ky.gov/parks/recreationparks/fort-boonesborough",
      "target": "_blank"
    }
  }, [_vm._v("parks.ky.gov/parks/recreationparks/fort-boonesborough")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('b', [_vm._v("Frankfort Cemetery")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("East Main Street")]), _vm._v(" "), _c('p', {
    staticClass: "noindentsb"
  }, [_vm._v("Frankfort, KY")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('b', [_vm._v("Fort Knox Saber & Quill")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("1118 Chaffee Avenue")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Fort Knox, KY")]), _vm._v(" "), _c('p', {
    staticClass: "noindentsb"
  }, [_vm._v("(859) 734-3314; "), _c('a', {
    attrs: {
      "href": "http://knox.armymwr.com/programs/saber-quill",
      "target": "_blank"
    }
  }, [_vm._v("knox.armymwr.com/programs/saber-quill")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('b', [_vm._v("Hardin County History Museum")])])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('p', {
    staticClass: "noindents"
  }, [_vm._v("201 West Dixie Avenue")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Elizabethtown, KY")])]), _c('p', {
    staticClass: "noindentsb"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("(270) 763-8339; ")]), _c('a', {
    attrs: {
      "href": "http://kentuckytourism.com/hardin-county-history-museum/184",
      "target": "_blank"
    }
  }, [_vm._v("kentuckytourism.com/hardin-county-history-museum/184")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('b', [_vm._v("Hardin County Public Library")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("100 Jim Owen Drive")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Elizabethtown, KY")]), _vm._v(" "), _c('p', {
    staticClass: "noindentsb"
  }, [_vm._v("(270) 769-6337; "), _c('a', {
    attrs: {
      "href": "http://hcpl.info",
      "target": "_blank"
    }
  }, [_vm._v("hcpl.info")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('b', [_vm._v("Jeptha Creed")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("500 Gordon Lane")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Shelbyville, KY")]), _vm._v(" "), _c('p', {
    staticClass: "noindentsb"
  }, [_vm._v("(502) 487-5007; "), _c('a', {
    attrs: {
      "href": "http://jepthacreed.com",
      "target": "_blank"
    }
  }, [_vm._v("jepthacreed.com")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('b', [_vm._v("Kentucky’s Lincoln Museum")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("66 Lincoln Square")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Hodgenville, KY")]), _vm._v(" "), _c('p', {
    staticClass: "noindentsb"
  }, [_vm._v("(270) 358-3163; "), _c('a', {
    attrs: {
      "href": "http://incolnmuseum-ky.org/Index.html",
      "target": "_blank"
    }
  }, [_vm._v("incolnmuseum-ky.org/Index.html")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('b', [_vm._v("Lincoln and Civil War Legacy Trail")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentsb"
  }, [_c('a', {
    attrs: {
      "href": "https://www.enjoyillinois.com/explore/listing/lincoln-and-civil-war-legacy-trail",
      "target": "_blank"
    }
  }, [_vm._v("https://www.enjoyillinois.com/explore/listing/lincoln-and-civil-war-legacy-trail")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('b', [_vm._v("Lincoln Homestead State Park")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("KY 258")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Springfield, KY")]), _vm._v(" "), _c('p', {
    staticClass: "noindentsb"
  }, [_vm._v("(859) 336-7461; "), _c('a', {
    attrs: {
      "href": "http://parks.ky.gov/parks/recreationparks/lincoln-homestead/",
      "target": "_blank"
    }
  }, [_vm._v("parks.ky.gov/parks/recreationparks/lincoln-homestead/")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('b', [_vm._v("The Lincoln Marriage Temple")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Old Fort Harrod State Park")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("100 South College Street")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Harrodsburg, KY")]), _vm._v(" "), _c('p', {
    staticClass: "noindentsb"
  }, [_vm._v("(859) 734-3314; "), _c('a', {
    attrs: {
      "href": "http://parks.ky.gov/parks/recreationparks/fort-harrod",
      "target": "_blank"
    }
  }, [_vm._v("parks.ky.gov/parks/recreationparks/fort-harrod")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('b', [_vm._v("Mordecai Lincoln House at Lincoln Homestead State Park")])])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('p', {
    staticClass: "noindents"
  }, [_vm._v("KY 258")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Springfield, KY")])]), _c('p', {
    staticClass: "noindentsb"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("(859) 336-7461; ")]), _c('a', {
    attrs: {
      "href": "http://parks.ky.gov/parks/recreationparks/lincoln-homestead",
      "target": "_blank"
    }
  }, [_vm._v("parks.ky.gov/parks/recreationparks/lincoln-homestead")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('b', [_vm._v("Old Fort Harrod State Park")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("100 South College Street")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Harrodsburg, KY")]), _vm._v(" "), _c('p', {
    staticClass: "noindentsb"
  }, [_vm._v("(859) 734-3314; "), _c('a', {
    attrs: {
      "href": "http://parks.ky.gov/parks/recreationparks/fort-harrod",
      "target": "_blank"
    }
  }, [_vm._v("parks.ky.gov/parks/recreationparks/fort-harrod")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('b', [_vm._v("Painted Stone Settlement")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("The Annual reenactment is held at Red Orchard Park:")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("709 Red Orchard Park")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Shelbyville, KY")]), _vm._v(" "), _c('p', {
    staticClass: "noindentsb"
  }, [_c('a', {
    attrs: {
      "href": "mailto:info@paintedstonesettler.org"
    }
  }, [_vm._v("info@paintedstonesettler.org")]), _vm._v("; "), _c('a', {
    attrs: {
      "href": "http://paintedstonesettlers.org",
      "target": "_blank"
    }
  }, [_vm._v("paintedstonesettlers.org")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('b', [_vm._v("Sarah Johnston Lincoln Cabin")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Blue Heron Way")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Freeman Lake Park")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Elizabethtown, KY 42701")]), _vm._v(" "), _c('p', {
    staticClass: "noindentsb"
  }, [_vm._v("(270) 769-3916")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_c('b', [_vm._v("Shaker Village of Pleasant Hill")])]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("3501 Lexington Road")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Harrodsburg, KY 40330")]), _vm._v(" "), _c('p', {
    staticClass: "noindentsb"
  }, [_vm._v("(859) 734-5411")]), _vm._v(" "), _c('p', {
    staticClass: "pgbreak"
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('i', [_c('b', [_vm._v("Abraham Lincoln")])]), _vm._v(" was born in a meager, one-room cabin about 20 miles south of Bardstown in Hodgenville, KY.")])]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("It had a dirt floor, one window, and a stick-clay chimney. Lincoln’s father, Tom, had paid $200 for the cabin and 300 acres of discouraging land. It wasn’t much, but it was a home and a chance for a better life.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("After four years of fighting mosquitos, heat and hardscrabble land, the Lincolns had to pack up and leave. There was a defect in the title. A trial was held at the Courthouse in Bardstown around 1812. The family stayed here at the Tavern. Abraham was quoted as being clad in a “one-piece long linsey shirt.”")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('i', [_c('b', [_vm._v("Sign in front of the Lincoln Room"), _c('br'), _vm._v("at the Old Talbott Tavern,"), _c('br'), _vm._v("Bardstown, Kentucky.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d8f9a90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/10_Chapter01.vue
// module id = 84
// module chunks = 0